var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"block-photo"},[(_vm.img)?_c('img',{attrs:{"src":require(`@/${_vm.img}`),"alt":""}}):_vm._e(),_c('div',{staticClass:"photo-sign"},[_vm._t("sign")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }